import styled, { css } from 'styled-components';

export const WeekSelectorContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const LegendSquareStyled = styled.div`
  ${({ theme }) => css`
    height: ${theme.spacings[450]};
    width: ${theme.spacings[450]};
    margin-right: ${theme.spacings[300]};
  `}
`;

export const LegendLineStyled = styled.div`
  ${({ theme }) => css`
    height: 1px;
    width: ${theme.spacings[450]};
    border: 1px solid ${theme.colors.black[400]};
    margin-right: ${theme.spacings[300]};
  `}
`;

interface RhombusProps {
  borderTopBottomColor: string | number;
}

//Reference: https://css-tricks.com/the-shapes-of-css/
export const LegendRhombusStyled = styled.div<RhombusProps>`
  ${({ borderTopBottomColor }) => css`
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: ${borderTopBottomColor};
    position: relative;
    top: -6px;
    margin-right: ${({ theme }) => theme.spacings[300]};

    &::after {
      content: '';
      position: absolute;
      left: -6px;
      top: 6px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-top-color: ${borderTopBottomColor};
    }
  `}
`;
